<div
  class="cb-sidebar-topbar"
  [ngClass]="['cb-size-' + size(), 'cb-theme-' + theme()]"
>
  @if (logo()) {
    <img [attr.src]="logo()" alt="Logo" [routerLink]="homeRoute" />
  }
  <div
    class="cb-sidebar-hamburger"
    (click)="toggleOpen()"
    [class.cb-open]="isOpen()"
  >
    <span></span>
    <span></span>
  </div>
</div>

<div
  class="cb-sidebar-main"
  [ngClass]="['cb-theme-' + theme(), 'cb-position-' + position()]"
  [class.cb-open]="isOpen()"
  [class.cb-compact]="compact()"
>
  <div class="cb-sidebar">
    <div class="cb-sidebar-navigation">
      @if (logo()) {
        <img [attr.src]="logo()" alt="Logo" [routerLink]="homeRoute" />
      }
      <div class="cb-sidebar-nav-items">
        @if (header()) {
          <ng-container *ngTemplateOutlet="header()!"></ng-container>
        }

        @for (item of ungroupedSidebarItems(); track $index) {
          <ng-container
            *ngTemplateOutlet="
              SidebarItemTemplate;
              context: { $implicit: item }
            "
          ></ng-container>
        }

        @for (groupData of groupedSidebarItems(); track groupData.group.id) {
          <p class="cb-sidebar-group-label">
            {{ groupData.group.label | translate }}
          </p>
          @for (item of groupData.items; track $index) {
            <ng-container
              *ngTemplateOutlet="
                SidebarItemTemplate;
                context: { $implicit: item }
              "
            ></ng-container>
          }
        }
      </div>
    </div>
    <div class="cb-sidebar-footer">
      <div class="cb-sidebar-page-users">
        <cb-users-avatar-list
          [usersIds]="usersOnSameRoute()"
          [enableAnimation]="true"
          [maxUsers]="6"
        ></cb-users-avatar-list>
      </div>

      @if (footer()) {
        <ng-container *ngTemplateOutlet="footer()!"></ng-container>
      }

      @if (footer()) {
        <ng-container *ngTemplateOutlet="footer()!"></ng-container>
      }

      @if (footerItems() && footerItems()!.length > 0) {
        <div class="cb-sidebar-nav-items">
          @for (item of footerItems(); track $index) {
            @if (
              (!item.show || item.show() !== false) &&
              (!item.showSignal || item.showSignal())
            ) {
              <div class="cb-sidebar-item-content">
                <cb-nav-item
                  [compact]="compact()"
                  [theme]="theme()"
                  [size]="size()"
                  (activationChange)="routeActivationChanged(item, $event)"
                  [navItem]="item"
                ></cb-nav-item>
              </div>
            }
          }
        </div>
      }

      @if (userId()) {
        @if (compact()) {
          <div
            class="cb-sidebar-avatar"
            [cbPopover]="profilePopover"
            [popoverDistance]="6"
            [showArrow]="false"
            popoverPosition="right"
            [closeOnInsideClick]="true"
          >
            <cb-user-avatar
              size="sm"
              [userId]="userId()!"
              [label]="profileName() || null"
              [onlyAvatar]="true"
            ></cb-user-avatar>
          </div>
        } @else {
          <div
            class="cb-sidebar-profile"
            [cbPopover]="profilePopover"
            [matchParentWidth]="true"
            [showArrow]="false"
            [closeOnInsideClick]="true"
          >
            <cb-user-avatar
              size="sm"
              [userId]="userId()!"
              [label]="profileName() || null"
              [subtitle]="profileEmail() || null"
            ></cb-user-avatar>

            <cb-icon name="cb-base-outline-chevron-selector-vertical"></cb-icon>
          </div>
        }
      }
    </div>
  </div>
  @if (currentSubSidebarItems().length > 0) {
    <div @subsidebar class="cb-sub-sidebar">
      @for (item of currentSubSidebarItems(); track $index) {
        @if (
          (!item.show || item.show() !== false) &&
          (!item.showSignal || item.showSignal())
        ) {
          <div class="cb-sidebar-item-content">
            <cb-nav-item
              [size]="size()"
              [theme]="theme()"
              (click)="subrouteClick(item)"
              [navItem]="item"
            ></cb-nav-item>
          </div>
        }
      }
    </div>
  }
</div>

<ng-template #profilePopover>
  <div class="cb-profile-popover">
    @if (!restrictedUserOptions()) {
      <div class="cb-profile-popover-group">
        @if (tenantName()) {
          <div class="cb-profile-popover-tenant">
            <cb-icon name="cb-base-bold-business"></cb-icon>
            <p>{{ tenantName() }}</p>
          </div>
        }
        <div class="cb-profile-popover-options">
          <div class="cb-profile-popover-option" (click)="changeTenant()">
            <cb-icon name="cb-base-outline-refresh"></cb-icon>
            <p>{{ "SECTIONS.ROUTES.CHANGE_TENANT" | translate }}</p>
          </div>
          <!-- <div class="cb-profile-popover-option" [routerLink]="createTenantUrl">
          <cb-icon name="cb-base-outline-add"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.CREATE_TENANT" | translate }}</p>
        </div> -->
        </div>
      </div>
    }
    <div class="cb-profile-popover-group">
      @if (userId()) {
        <div class="cb-profile-popover-avatar">
          <cb-user-avatar
            [userId]="userId()!"
            size="sm"
            [subtitle]="profileEmail() || null"
          ></cb-user-avatar>
        </div>
      }
      <div class="cb-profile-popover-options">
        <div class="cb-profile-popover-option" (click)="contactSupport()">
          <cb-icon name="cb-base-outline-help"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.CONTACT_SUPPORT" | translate }}</p>
        </div>
        <div class="cb-profile-popover-option" (click)="reportBug()">
          <cb-icon name="cb-base-outline-bug"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.REPORT_BUG" | translate }}</p>
        </div>
        @if (!restrictedUserOptions()) {
          <div class="cb-profile-popover-option" [routerLink]="userSettingsUrl">
            <cb-icon name="cb-base-outline-settings"></cb-icon>
            <p>{{ "SECTIONS.ROUTES.USER_SETTINGS" | translate }}</p>
          </div>
        }
        <div class="cb-profile-popover-option cb-error" (click)="logout.emit()">
          <cb-icon name="cb-base-outline-logout"></cb-icon>
          <p>{{ "SECTIONS.ROUTES.LOGOUT" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #SidebarItemTemplate let-item>
  @if (
    (!item.show || item.show() !== false) &&
    (!item.showSignal || item.showSignal())
  ) {
    <div class="cb-sidebar-item-content">
      <cb-nav-item
        [compact]="compact()"
        [size]="size()"
        (activationChange)="routeActivationChanged(item, $event)"
        [theme]="theme()"
        [navItem]="item"
      ></cb-nav-item>

      @if (item.type === "collapsible" && item.isOpen) {
        @for (navItem of navItems(); track $index) {
          @if (
            !navItem.show ||
            (navItem.show() !== false &&
              (!navItem.showSignal || navItem.showSignal()))
          ) {
            <ng-container
              *ngTemplateOutlet="
                SidebarItemTemplate;
                context: { $implicit: navItem }
              "
            ></ng-container>
            <!-- <div class="cb-sidebar-item">
      <div class="cb-sidebar-item-content">
        @if (navItem.icon) {
        <cb-icon [name]="navItem.icon"></cb-icon>
        }
        @if(!compact()){
        <p>
          {{ navItem.label }}
        </p>
        }
      </div>
    </div> -->
          }
        }
      }
    </div>
  }
</ng-template>
